<template>
  <div id="app" v-loading="pageLoading">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App',
  computed: {
    pageLoading () {
      return this.$store.state.app.pageLoading.pageLoadingStatus
    }
  }
}
</script>

<style>
  .el-input__inner {
    width: 100% !important;
  }

  /* html,
  body {
    min-width: 1280px;
    overflow-x: hidden;
  } */
</style>
